import ItemManufacture from '../item-manufacture/item-manufacture.vue'

export default {
  name: 'ManufactureSelectList',
  components: {
    ItemManufacture
  },
  props: {
    cities: {
      /**
       * массив объектов вида
       * {
          "id": 0,
          "title": "string",
          "manufactures": [
            {
              "id": 12,
              "title": "Гастелло",
              "city_id": 2,
              "coordinates": {},
              "current_admin": {
                "admin_id": 1,
                "first_name": "Валентин",
                "last_name": "Гусев"
              }
            }
          ]
        }
       */
      type: Array,
      required: true
    }
  },
  data() {
    return {
      /**
       * ссылка на объект из массива
       */
      selectedCity: null
    }
  },
  mounted() {
    this.selectedCity = this.cities[0]
  },
  methods: {
    setSelectedCity(city) {
      this.selectedCity = city
    },
    onSelectItem(item) {
      this.$emit('submit-manufacture', {
        selectedCity: this.selectedCity,
        selectedManufacture: item
      })
    }
  }
}